import type { CrewField } from '@/raptorjob/presentation/components/RaptorJobCreatePage/RaptorJobCreateModal';

/**
 * Validates resources form fields
 * @returns Object with validation results
 */
export const validateResourcesForm = (
  selectedSize: { id?: string | number | null; name?: string | null } | null,
  crewFields: CrewField[]
): {
  isValid: boolean;
  errors: {
    equipmentSize?: string;
    crew?: string;
  };
} => {
  const errors: {
    equipmentSize?: string;
    crew?: string;
  } = {};

  // Validate equipment size is required
  if (!selectedSize?.id) {
    errors.equipmentSize = 'Equipment size is required';
  }

  // Validate crew entries: if a crew entry exists, both roleId and employeeId must be filled
  // An entry is invalid if:
  // - It has only roleId filled (missing employeeId)
  // - It has only employeeId filled (missing roleId)
  // - It has both empty (incomplete entry)
  const incompleteCrewEntries = crewFields.filter((crew) => crew.roleId == null || crew.employeeId == null);

  if (incompleteCrewEntries.length > 0) {
    errors.crew = 'All crew entries must have both Role and Employee selected';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};
